import { useLayoutEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { animateAppearance, animateSlide } from '../../../services/animations';
import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';

import { SamOnboardingImage } from './OnboardingImage';
import { OnboardingOverlay } from './OnboardingOverlay';
import {
  StyledOnboardingContainer,
  StyledOnboardingTitle,
  StyledSamLogo,
  StyledStartButton,
  StyledSubtitle,
  OnboardingActionsTab,
} from './styles';

export const OnboardingView = () => {
  const { t } = useTranslation();
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const imageRef = useRef<SVGSVGElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);
  const subtitleRef = useRef<HTMLParagraphElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const overlayRef = useRef<HTMLDivElement>(null);
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  useLayoutEffect(() => {
    [imageRef.current, titleRef.current, subtitleRef.current, buttonRef.current].forEach((el) => {
      if (el) {
        el.style.opacity = '0';
      }
    });

    animateAppearance(titleRef.current, 'appear')
      ?.finished.then(() => animateAppearance(subtitleRef.current, 'appear')?.finished)
      .then(() => animateAppearance(imageRef.current, 'appear')?.finished)
      .then(() => animateAppearance(buttonRef.current, 'appear')?.finished)
      .catch(console.error);
  }, []);

  const handleStartOnboarding = () => {
    dispatchTrackEventWithLocation('preferences', 'click get started', 'start onboarding');
    animateSlide(overlayRef.current, 'up')
      ?.finished.then(() => setIsOverlayOpen(true))
      .catch(console.error);
  };

  const handleCloseOnboarding = () => {
    setIsOverlayOpen(false);
    animateSlide(overlayRef.current, 'down');
  };

  return (
    <>
      {!isOverlayOpen ? (
        <StyledOnboardingContainer>
          <div ref={titleRef}>
            <StyledOnboardingTitle>{t('insights.onboarding.meet')}</StyledOnboardingTitle>
            <StyledSamLogo />
          </div>
          <StyledSubtitle ref={subtitleRef}>{t('insights.onboarding.subtitle')}</StyledSubtitle>
          <SamOnboardingImage ref={imageRef} />
          <OnboardingActionsTab>
            <StyledStartButton ref={buttonRef} onClick={handleStartOnboarding}>
              {t('insights.onboarding.get_started')}
            </StyledStartButton>
          </OnboardingActionsTab>
        </StyledOnboardingContainer>
      ) : null}
      <OnboardingOverlay ref={overlayRef} onClose={handleCloseOnboarding} />
    </>
  );
};
